import { countTotalAllDivs } from "../helpers/countTotal.js";
import { betItemFunc } from "../bet/betItemFunc.js";
import { items } from "../helpers/items.js";
import { toFixed, addUrlParameter, getUrlParameter } from '../global.js';

    // Uncheck all item checkboxes inside inventory after page load
    $('#js__items input.item_checkbox_js').prop('checked', false);

    //uncheck all team radio buttons
    $('.teams-archive__item .bet-item:not(.active) input.input-hidden').prop('checked', false);

    // Set input range value to 0 and trigger change event
    $('input.input-range').val(0).trigger('change');
    $('input.input-range-value').val(0).trigger('change');
    $('input[name="user_betcoin"]').val(0);


//click on bet type
$('.teams-archive__item').on('click', function (e) {
    if ($(e.target).is('input.input-hidden')) {
        return;
    }
    let $bet_item = $(this).find('.bet-item');
    //if has class disabled or active do nothing
    if ($bet_item.hasClass('disabled') || $bet_item.hasClass('active')) {
        e.preventDefault();
        // if ($(this).hasClass('active')) {
        //     $(this).removeClass('active');
        //     $(this).find('.input-hidden').prop("checked", false);
        // }
        return;
    }
    let $event_wrap = $(this).closest('.event-wrap');
    $event_wrap.find('.bet-item').removeClass('active');
    $event_wrap.find('.bet-item .input-hidden').prop("checked", false);
    $bet_item.addClass('active');
    $bet_item.find('.input-hidden').prop("checked", true);
    updateAboutDiv();
    countTotalAndProfit();
});

$('.event-item input.type_radio').on('click', function (e) {
    let $event_item = $(this).closest('.event-item');
    //if has class disabled
    if ($event_item.hasClass('disabled')) {
        e.preventDefault();
        return;
    }
    let bet_type = $event_item.data('type');
    addUrlParameter('type', bet_type);
    //hide all $('.bet-content[data-type]') and show only one with data-type 
    $('.bet-content[data-type]').hide();
    if ($(`.bet-content[data-type="${bet_type}"]`).length != 0) {
        $(`.bet-content[data-type="${bet_type}"]`).show();
    } else {
        $(`.bet-content[data-type="none"]`).show();
    }
    updateAboutDiv();
    countTotalAndProfit();
});


let ignore_countTotalAndProfit = false;
function countTotalAndProfit() {
    if (ignore_countTotalAndProfit) {
        return;
    }
    countTotalAllDivs();
    let $total_in_bet = $('.js_teams-bet__profit-for:visible');
    let $total_profit = $('.js_teams-bet__profit-get:visible');
    if ($total_in_bet.length == 0) {
        update_buttons_to_bet();
        return;
    } else {
        let total_in_bet = parseFloat($('.in_bet:visible .user_items_price').text());
        let $bet_cof = $('.tab-item.active .bet-item.active span[data-cof]');
        let cof = parseFloat($bet_cof.data('cof'))
        let total_profit = total_in_bet * cof;
        $total_in_bet.text(toFixed(total_in_bet, 2));
        $total_profit.text(toFixed(total_profit, 2));
        update_buttons_to_bet();
    }
}

countTotalAndProfit();

//items clicks
$('.block__item').on('click', '.pay__item', function (e) {
    if ($(this).find('input[type=checkbox]').length == 0) {
        return;
    }
    let in_bet_div = $('.form_for_js_in_div .in_bet.bet-content .bet-content-show:visible');
    let user_inventory_div = $('#js__items')
    if ($(this).parents('#js__items').length) {
        //in inventory click move to in_bet
        //if bet is started do nothing
        if ($('.bet-item.active.started').length != 0) {
            return;
        }
        //set hidden input checked true
        $(this).find('input.item_checkbox_js').prop('checked', true);
        in_bet_div.append($(this));
    } else {
        if ($('.bet-item.active.started').length != 0) {
            return;
        }
        //if item was in bet onload do nothing
        if ($(this).find('input.item_checkbox_js').length == 0) {
            return;
        }
        //set hidden input checked false
        $(this).find('input.item_checkbox_js').prop('checked', false);
        //in bet click move to inventory
        user_inventory_div.append($(this));
    }
    countTotalAndProfit();
});

//items all in button
$('.bet-content').on('click', '#all-in', function () {
    if ($('.bet-item.active.started').length != 0) {
        return;
    }
    click_all_in();
});

function click_all_in() {
    ignore_countTotalAndProfit = true;
    $('#js__items .pay__item:visible').click();
    ignore_countTotalAndProfit = false;
    countTotalAndProfit();
}

//cancel bet button
$('.in_bet').on('click', '.bet-content-cancel', function () {
    if ($('.bet-item.active.started').length != 0) {
        return;
    }
    click_all_items_in_bet();
});

function click_all_items_in_bet() {
    ignore_countTotalAndProfit = true;
    $('.in_bet .pay__item').click();
    ignore_countTotalAndProfit = false;
    countTotalAndProfit();
}

//adding betcoins
$('.button-block').on('input change', 'input.input-range', function () {
    var $betcoin_div = $('.in_bet:visible  .bet-content-coin');
    var $betcoin_span = $betcoin_div.find('span[data-betcoin]');
    var current_value = Number($betcoin_span.data('betcoin'));
    var added_value = Number($(this).val());
    if (!$(this).is(':visible')) {
        added_value = 0;
    }
    // if (Number($('input.bet-content__range_value:visible').val()) != $added_value) {
    //     $('input.bet-content__range_value:visible').val($added_value);
    // }
    var total_bet_value = Number(current_value + added_value);
    if (total_bet_value <= 0) {
        total_bet_value = 0;
        $betcoin_div.addClass('hidden');
    } else {
        $betcoin_div.removeClass('hidden');
    }
    $betcoin_span.html(toFixed(total_bet_value, 2));

    //главный инпут куда надо записать валуе
    $('input[name="user_betcoin"').val(added_value);

    countTotalAndProfit();
});

$('.button-block').on('focusout', 'input.input-range-value', function () {
    if ($(this).val() == '') {
        $(this).val(0);
    }
});

$('.button-block').on('focus', 'input.input-range-value', function () {
    if ($(this).val() == 0) {
        $(this).val('');
    }
});


function update_buttons_to_bet(active_event_div) {
    if (!active_event_div) {
        active_event_div = $('.event-item.active');
    }
    //let bet_type = active_event_div.data('type');
    let bets_count = active_event_div.data('bets_count');
    let status = active_event_div.data('status');

    //кнопка плейс бет активна если  data-bets_count= 0 и data-status = 0 
    //если data-bets_count > 0  и data-status = 0  то активны кнопки отмены и апдейта ставки
    //для лайв ставок у нас кнопка создания ставки была активна все время, пока есть этот тип ставки, но может её можно скрывать, когда нельзя сделать ставку (замочек)
    let place_bet_button = $('#place-bet');
    let update_bet_button = $('#update-bet');
    let cancel_bet_button = $('#cancel-bet');
    let buttons_block = $('.button-block');
    let inventory_div = $('#inventory');
    let remove_items_button = $('.in_bet:visible .bet-content-cancel');
    let items_in_bet_count = $('.in_bet:visible .pay__item input.item_checkbox_js').length
    if (status == 0) {
        //матч не стартанул
        buttons_block.show();
        inventory_div.show();
        if (items_in_bet_count != 0) {
            remove_items_button.show();
        } else {
            remove_items_button.hide();
        }

        if (bets_count == 0) {
            //ставок нет
            place_bet_button.show();
            update_bet_button.hide();
            cancel_bet_button.hide();
        } else if (bets_count > 0) {
            //ставки есть
            place_bet_button.hide();
            update_bet_button.show();
            cancel_bet_button.show();
        }
    } else {
        //матч стартанул
        buttons_block.hide();
        inventory_div.hide();
        remove_items_button.hide();
    }

    window.dispatchEvent(new Event('resize'));
}

function updateAboutDiv() {
    let bet_title = $('.event-item.active').find('.event-item__title').text();
    //let bets_count = bet_title.data('bets_count');
    let status = $('.event-item.active').data('status');
    let selected_team = $('.tab-item.active .bet-item.active').parent().find('.teams-archive__item-title').text();
    let $about_div = $('#tournament__notification_block_2');
    let $no_cof_div = $('#tournament__notification_block_5');
    let $closed_div = $('#tournament__notification_block_6');
    if (status == 1) {
        $about_div.hide();
        $no_cof_div.hide();
        $closed_div.show();
        return;
    }
    if (bet_title=='' || selected_team=='') {
        $about_div.hide();
        $closed_div.hide();
        $no_cof_div.show();
    } else {
        $closed_div.hide();
        $no_cof_div.hide();
        $about_div.show();
    }
    let type_icon_src = $('.event-item.active').find('.event-item__team img').attr('src');
    let team_icon_src = $('.tab-item.active .bet-item.active').closest('.teams-archive__item').find('img').attr('src');
    $about_div.find('.teams-bet__about-title').text(bet_title);
    $about_div.find('.teams-bet__about-team-name').text(selected_team);

    if (type_icon_src) {
        var img = $(`<img class="teams-bet__about-icon c-important icon to-svg" src="${type_icon_src}">`);
        $about_div.find('.teams-bet__about-icon').replaceWith(img);
        toSVG();
    } else {
        $about_div.find('.teams-bet__about-icon').hide();
    }
}


// document.addEventListener('DOMContentLoaded', () => {
//     //onload click on bet_type from url parameter if have one
//     let bet_type = getUrlParameter('type');
//     if (bet_type) {
//         $(`.event-item[data-type="${bet_type}"]`).click();
//     }
// });

